import React from 'react'

export const IconInfo = () => {
  return <img src="https://icongr.am/clarity/info-circle.svg?size=16&amp;" alt="icon" />
}
